import { CSSProperties } from "react";
import Colors from "modules/Colors";
import Sty from "modules/Sty";
import CardSymphony from "elements/CardSymphony";
import ButtonSymphony from "elements/ButtonSymphony";
import TagSymphony from "elements/TagSymphony";
import { clsx, makeKey } from "modules/Utils";

interface Tag {
    id: string | number;
    title: string;
    [key: string]: any;
}

interface MaestroAdCardProps {
    className: string;
    title: string;
    description: string;
    onClick?: () => void;
    tags?: Tag[] | null | undefined;
    buttonText?: string;
    tagColor?: string;
}

const MaestroAdCard = ({
    className,
    title,
    description,
    onClick,
    tags,
    buttonText = 'Add',
    tagColor = 'purple'
}: MaestroAdCardProps) => {
    return (
        <div className={clsx("maestroAdCardComponent", className)} style={sty.maestroAdCardComponent}>
            <div className="titleDescriptionAndButtonContainer" style={sty.titleDescriptionAndButtonContainer}>
                <CardSymphony
                    className="maestroAdCardHeader"
                    title={title}
                    subtitle={description}
                    size="small"
                    isNoPadding
                    style={{ backgroundColor: 'none' }}
                />
                {onClick &&
                    <ButtonSymphony
                        className="maestroAdCardButton"
                        onClick={onClick}
                        title="Edit"
                        variant="outlined"
                    >
                        {buttonText}
                    </ButtonSymphony>
                }
            </div>
            <div className="maestroTagRow" style={sty.maestroTagRow}>
                {tags?.map((tag, index) => (
                    <TagSymphony
                        key={makeKey('maestro-tag', tag.id, index)}
                        className="maestroTag"
                        color={tagColor as any}
                        tag={tag}
                    >
                        {tag.title}
                    </TagSymphony>
                ))}
            </div>
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    maestroAdCardComponent: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        padding: 16,
        border: Sty.border,
        borderRadius: 16,
        width: '100%',
        background: `url(${require('assets/images/recommendation-card-blurred-background.png').default}) no-repeat center center`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    titleDescriptionAndButtonContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
    maestroTagRow: {
        display: 'flex',
        flexDirection: 'row',
        gap: 8,
        flexWrap: 'wrap',
    },
    maestroTag: {
        color: Colors.purple,
    }
}

export default MaestroAdCard;